<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'orderDetailDialog',
})
</script>
<template>
  <ant-Modal v-model:open="state.dialog.visible" transition-name="" :centered="true"
    :wrap-class-name="'wrap-order-detail-dialog'" :title="'订单信息'" :width="state.dialog.width"
    :ok-text="state.dialog.submitTxt" :cancel-button-props="{ style: { display: 'none' } }" @ok="closeDialog"
    @cancel="closeDialog" :maskClosable="false" :keyboard="false" :closable="false">
    <div class="form-content">
      <!-- 订单信息 -->
      <div class="detail-section first-section">
        <a-row :gutter="[60, 20]" class="detail-grid">
          <a-col :span="12">
            <div class="detail-item">
              <span class="detail-label">订单编号：</span>
              <span class="detail-value">{{ state.info.orderNo || '-' }}</span>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="detail-item">
              <span class="detail-label">订单类型：</span>
              <span class="detail-value">{{ getOrderTypeText(state.info.orderType) }}</span>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="detail-item">
              <span class="detail-label">下单时间：</span>
              <span class="detail-value">{{ state.info.orderTime || '-' }}</span>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="detail-item">
              <span class="detail-label">订单状态：</span>
              <span class="detail-value">{{ state.info.orderStatusDesc || getStatusText(state.info.orderStatus) }}</span>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="detail-item">
              <span class="detail-label">支付方式：</span>
              <span class="detail-value">{{ state.info.payTypeDesc || state.info.payType || '-' }}</span>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="detail-item">
              <span class="detail-label">支付时间：</span>
              <span class="detail-value">{{ state.info.payTime || '-' }}</span>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="detail-item">
              <span class="detail-label">订单金额：</span>
              <span class="detail-value">{{ state.info.orderAmount != null ? `¥${state.info.orderAmount}` : '-' }}</span>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="detail-item">
              <span class="detail-label">支付金额：</span>
              <span class="detail-value">{{ state.info.payAmount != null ? `¥${state.info.payAmount}` : '-' }}</span>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="detail-item">
              <span class="detail-label">关联单号：</span>
              <span class="detail-value">{{ state.info.transactionId || '-' }}</span>
            </div>
          </a-col>
        </a-row>
      </div>

      <!-- 商品信息 -->
      <div class="detail-section">
        <div class="section-title">商品信息</div>
        <div class="section-line" />
        <div class="product-row">
          <div v-if="isValidImageUrl(state.info.productImg)" class="product-img-block">
            <img :src="state.info.productImg" class="product-img" />
          </div>
          <div v-else class="product-img-block placeholder">
            <PictureOutlined />
          </div>
          <div class="product-detail">
            <div class="detail-item">
              <span class="detail-label">展览名称：</span>
              <span class="detail-value">{{ state.info.productName || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">展览日期：</span>
              <span class="detail-value">{{ exhibitionDateRange }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">参展日期：</span>
              <span class="detail-value">{{ state.info.sessionDate || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">场次：</span>
              <span class="detail-value">{{ state.info.sessionDesc || state.info.timeSlotName || '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">单价：</span>
              <span class="detail-value">{{ state.info.unitPrice != null ? `¥${state.info.unitPrice}` : '-' }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">数量：</span>
              <span class="detail-value">{{ state.info.totalQuantity ?? '-' }}</span>
            </div>
          </div>
          <div class="product-img-placeholder-right" />
        </div>
      </div>

      <!-- 核销明细 -->
      <div class="detail-section">
        <div class="section-title">核销明细</div>
        <div class="section-line" />
        <div class="verification-table">
          <div class="verification-row verification-header">
            <span>门票ID</span>
            <span>状态</span>
            <span>核销时间</span>
          </div>
          <template v-if="verificationItems.length">
            <div v-for="item in verificationItems" :key="item.id" class="verification-row">
              <span :title="String(item.id)">{{ item.id || '-' }}</span>
              <span>{{ getItemStatusText(item) }}</span>
              <span>{{ getItemVerificationTime(item) }}</span>
            </div>
          </template>
          <div v-else class="verification-empty">暂无核销明细</div>
        </div>
      </div>

      <!-- 用户信息 -->
      <div class="detail-section">
        <div class="section-title">用户信息</div>
        <div class="section-line" />
        <a-row :gutter="[60, 20]" class="detail-grid">
          <a-col :span="12">
            <div class="detail-item">
              <span class="detail-label">用户昵称：</span>
              <span class="detail-value">{{ state.info.userNickname || state.info.userName || '-' }}</span>
            </div>
          </a-col>
          <a-col :span="12">
            <div class="detail-item">
              <span class="detail-label">用户手机号：</span>
              <span class="detail-value">{{ state.info.userTel || '-' }}</span>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </ant-Modal>
</template>

<script setup lang="ts" name="orderDetailDialog">
import { reactive, computed, ref } from 'vue'
import { PictureOutlined } from '@ant-design/icons-vue'
import { useOrder } from '@/store/order/order'
import { message } from 'ant-design-vue'

const orderStore = useOrder()

const state = reactive({
  dialog: {
    visible: false,
    title: '订单信息',
    submitTxt: '关闭',
    width: '969px'
  },
  info: {} as any,
  orderStatusOptions: [] as Array<{ code: string | number; name: string }>
})

const imgError = ref(false)

const isValidImageUrl = (url?: string) => {
  if (!url) return false
  return /^https?:\/\//i.test(url)
}

const exhibitionDateRange = computed(() => {
  if (state.info.exhibitionDate) {
    return state.info.exhibitionDate
  }
  if (state.info.startDate && state.info.endDate) {
    return `${state.info.startDate} 至 ${state.info.endDate}`
  }
  return state.info.sessionDate || '-'
})

const verificationItems = computed(() => {
  return Array.isArray(state.info.items) ? state.info.items : []
})

const getOrderTypeText = (type?: string) => {
  switch (type) {
    case 'ticket': return '门票'
    case 'goods': return '实物商品'
    default: return type || '-'
  }
}

const getStatusText = (status?: number) => {
  const option = state.orderStatusOptions.find((item) => String(item.code) === String(status))
  return option?.name || '未知'
}

const getItemStatusText = (item: any) => {
  if (item.itemStatusDesc) return item.itemStatusDesc
  return Number(item.itemStatus) === 2 ? '已核销' : '未核销'
}

const getItemVerificationTime = (item: any) => {
  return Number(item.itemStatus) === 2 ? item.writeOffTime || '—' : '—'
}

const openDialog = async (row: any, orderStatusOptions: Array<{ code: string | number; name: string }> = []) => {
  if (!row?.id) return
  imgError.value = false
  state.orderStatusOptions = orderStatusOptions
  try {
    const data: any = await orderStore.getOrderDetail(row.id)
    state.info = data || {}
    state.dialog.visible = true
  } catch {
    state.info = {}
    message.error('获取订单详情失败')
  }
}

const closeDialog = () => {
  state.dialog.visible = false
}

defineExpose({
  openDialog,
  closeDialog
})
</script>

<style scoped lang="less">
@content-padding-x: 30px;
@detail-indent: 13px;
@product-side-width: 106px;

.form-content {
  padding: 24px @content-padding-x 16px;
}

.detail-section {
  & + .detail-section {
    margin-top: 32px;
  }

  &.first-section {
    margin-top: 0;

    .section-line {
      margin-bottom: 23px;
    }
  }
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  line-height: 1;
  color: #222;
  margin-bottom: 23px;
}

.section-line {
  height: 1px;
  background: #A0B8E5;
  margin: 0 -@content-padding-x 23px;
}

.detail-grid {
  padding: 0 @detail-indent;

  .detail-item {
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    line-height: 1.5;

    .detail-label {
      flex-shrink: 0;
      text-align: right;
      color: #5c5757;
    }

    .detail-value {
      flex: 1;
      word-break: break-all;
      color: #222;
    }
  }
}

.product-img-block {
  width: 106px;
  height: 106px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;

  &.placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f5f5;
    color: #0B0B0B;
    font-size: 28px;

    :deep(svg),
    :deep(.anticon) {
      color: #0B0B0B !important;
      fill: #0B0B0B !important;
    }
  }
}

.product-img {
  width: 106px;
  height: 106px;
  object-fit: cover;
  display: block;
}

.product-row {
  display: flex;
  align-items: flex-start;
  padding: 0 @detail-indent;
}

.product-img-placeholder-right {
  width: @product-side-width;
  flex-shrink: 0;
}

.product-detail {
  flex: 1;
  margin: 0 37px;
  display: grid;
  grid-template-columns: 1fr 60px 1fr;
  gap: 20px 0;
  align-items: start;

  .detail-item {
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    line-height: 1.5;

    .detail-label {
      flex-shrink: 0;
      text-align: right;
      color: #5c5757;
    }

    .detail-value {
      flex: 1;
      word-break: break-all;
      color: #222;
    }

    &:nth-child(1) {
      grid-column: 1;
      grid-row: 1;
    }

    &:nth-child(2) {
      grid-column: 3;
      grid-row: 1;
    }

    &:nth-child(3) {
      grid-column: 1;
      grid-row: 2;
    }

    &:nth-child(4) {
      grid-column: 3;
      grid-row: 2;
    }

    &:nth-child(5) {
      grid-column: 1;
      grid-row: 3;
    }

    &:nth-child(6) {
      grid-column: 3;
      grid-row: 3;
    }
  }
}

.verification-table {
  padding: 0 @detail-indent;
}

.verification-row {
  display: grid;
  grid-template-columns: minmax(220px, 1.4fr) minmax(120px, 0.8fr) minmax(180px, 1fr);
  column-gap: 24px;
  min-height: 34px;
  align-items: center;
  color: #222;
  font-size: 14px;

  span {
    min-width: 0;
    word-break: break-all;
  }
}

.verification-header {
  min-height: 32px;
  color: #5c5757;
}

.verification-empty {
  padding: 8px 0;
  color: #999;
  font-size: 14px;
  text-align: center;
}

:global(.wrap-order-detail-dialog .ant-modal-body) {
  padding: 0;
  border-radius: 4px;
  max-height: calc(100vh - 180px);
  overflow-y: auto;
}

:global(.wrap-order-detail-dialog .ant-modal-content) {
  padding-bottom: 0;
}

:global(.wrap-order-detail-dialog .ant-modal-footer) {
  padding: 16px @content-padding-x 24px;
  text-align: center;
  border-top: none;
}

:global(.wrap-order-detail-dialog .ant-modal-footer .ant-btn-primary) {
  background: #0B0B0B !important;
  border-color: #0B0B0B !important;
}

:global(.wrap-order-detail-dialog .ant-modal-close) {
  display: none;
}
</style>
